"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectValidator = void 0;
const ElementValidatorUtil_1 = require("./ElementValidatorUtil");
const DOM_1 = require("../DOM");
class SelectValidator {
    static validateSelect(select) {
        const params = ElementValidatorUtil_1.ElementValidatorUtil.getValidationParams(select);
        if (params.filled) {
            this.validateSelectFilled(select, params.filled);
        }
        if (params.revalidate) {
            this.processRevalidate(params.revalidate);
        }
    }
    static validateSelectFilled(element, params) {
        const value = element.value.trim();
        if (value.toString().length < 1) {
            element.dataset.valid = "false";
            const parentElement = element.parentElement;
            if (parentElement?.classList.contains('select-wrapper')) {
                parentElement.dataset.valid = "false";
            }
            ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, false);
            return;
        }
        ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(element, params.problem, true);
    }
    static processRevalidate(params) {
        const event = new Event("change");
        for (const elementName of params.nameList) {
            const element = DOM_1.DOM.Parser.getHtmlInputElementByName(elementName);
            element.dispatchEvent(event);
        }
    }
}
exports.SelectValidator = SelectValidator;
